var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextButtonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-3bd04428-b40a-4fe1-9787-115fd72e55d2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.93 10.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-08f8b232-b88e-45ca-ab60-e7c45cb691d9{fill:#f7f2ee;}.uuid-35949f55-2fa0-4699-af19-e3bcc9d86ade{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:.7px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-ba2acabc-a516-4384-897a-a1fe22d48f0f"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-08f8b232-b88e-45ca-ab60-e7c45cb691d9",
    cx: 5.46,
    cy: 5.46,
    r: 5.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.77,
    y: 5.07,
    width: 4.78,
    height: 0.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-35949f55-2fa0-4699-af19-e3bcc9d86ade",
    x1: 6.95,
    y1: 4.03,
    x2: 8.16,
    y2: 5.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-35949f55-2fa0-4699-af19-e3bcc9d86ade",
    x1: 8.16,
    y1: 5.23,
    x2: 6.95,
    y2: 6.87
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButtonIcon);
export default __webpack_public_path__ + "static/media/next_button_icon.232c243fd06fd818392fdf8b7cd1175a.svg";
export { ForwardRef as ReactComponent };